// extracted by mini-css-extract-plugin
module.exports = {"Layout":"Layout_Layout__1ST27","Sidebar":"Layout_Sidebar__1b5MQ","Main":"Layout_Main__2739o","Scrolling":"Layout_Scrolling__1t2vU"};